import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddBrand = createAsyncThunk(
  "other/AddBrand",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/brand/create/`, data)
    return response.data
  }
); 

export const UpdateBrand = createAsyncThunk(
  "other/UpdateBrand",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/brand/update/${data.id}/`, data)
    return response.data
  }
);

export const DeleteBrand = createAsyncThunk(
  "other/DeleteBrand",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/brand/delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

export const GetBrands = createAsyncThunk(
  "other/GetBrands",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/brand/list/`);
    return data
  }
);

